import http from "../../../../core/utils/apis/skillApi";


const getSkillsList = async (options) => {
  try {
    const response = await http({
      method: "GET",
      url: "/skills",
      params: options,
    });
    console.log("API Response:", response.data); 
    return response.data;
  } catch (e) {
    console.error("Error fetching skills list:", e);
    throw e;
  }
};
const createSkill = async (skillData) => {
  try {
    const response = await http({
      method: "POST",
      url: "/skills",
      data: skillData,
    });
    return response.data;
  } catch (e) {
    console.error("Error creating skill:", e);
    throw e;
  }
};


const updateSkill = async (id, skillData) => {
  try {
    console.log("🟡 Sending update request:", JSON.stringify(skillData, null, 2));

    const response = await http({
      method: "PATCH",
      url: `/skills/${id}`,
      data: skillData,
      headers: { "Content-Type": "application/json" }, 
    });

    return response.data;
  } catch (e) {
    console.error("❌ Error updating skill:", e.response?.data || e);
    throw e;
  }
};

const deleteSkill = async (id) => {
  try {
    const response = await http({
      method: "DELETE",
      url: `/skills/${id}`,
    });
    return response.data;
  } catch (e) {
    console.error("Error deleting skill:", e);
    throw e;
  }
};

const activateSkill = async (id) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/skills/${id}/activate`,
    });
    return response.data;
  } catch (e) {
    console.error("Error activating skill:", e);
    throw e;
  }
};


const deactivateSkill = async (id) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/skills/${id}/deactivate`,
    });
    return response.data;
  } catch (e) {
    console.error("Error deactivating skill:", e);
    throw e;
  }
};

const skillManagementService = {
  getSkillsList,
  createSkill,
  updateSkill,
  deleteSkill,
  activateSkill,
  deactivateSkill,
};

export default skillManagementService;
